<template>
  <div class="language-selector">
    <span
      v-for="(lang, i) in langs"
      :key="`lang-${i}`"
      :class="( lang.code == $i18n.locale ? 'active': 'inactive' )"
      @click="setLanguage(lang.code)"
    >
      <flag
        :iso="lang.flag_code"
        :title="lang.description"
        :squared="false"
      />
    </span>
  </div>
</template>

<script>
import FlagIcon from 'vue-flag-icon'
import Vue from 'vue'
Vue.use(FlagIcon)

export default {
  name: 'SwitchLanguage',
  computed: {
    langs() {
        return this.$store.getters['language/getList']
    },
  },
  watch: {
    '$i18n.locale': function() {
        this.syncLanguage()
    },
  },
  beforeUpdate() {
    this.syncLanguage()
  },
  methods: {
    syncLanguage() {
        this.$vuetify.lang.current = this.$i18n.locale
    },
    setLanguage(lang) {
      this.$i18n.locale = lang
    },
  },
}
</script>

<style scoped>
select {
    width: 20px;
    color: black;
}
.flag-icon {
    margin-right: 5px
}
div.language-selector .inactive {
  opacity: 0.4;
}
</style>

